import { render, staticRenderFns } from "./ConsultBranchStatisticPage.vue?vue&type=template&id=5847b2a4"
import script from "./ConsultBranchStatisticPage.vue?vue&type=script&lang=ts"
export * from "./ConsultBranchStatisticPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultBranchStatisticPage.vue?vue&type=style&index=0&id=5847b2a4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports